var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"e-button",class:{ 'e-button--disabled': _vm.disabled },on:{"click":_vm.onClick}},[_c('div',{staticClass:"e-button__inner"},[_c('span',{ref:"content",staticClass:"transition-in"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }